import { createSelector } from 'reselect'
import { PackageResource } from 'types/typescript'
import {
  GetCapacityConf,
  GetMaxPax,
  GetMinEqualsMaxPax,
  GetMinPax,
  GetParticipantsSettings
} from './pricerCapacity.types'
import { getActivePackage } from './package'

export const getParticipantsSettings: GetParticipantsSettings = createSelector(
  getActivePackage,
  (activePackage: PackageResource) => activePackage?.ecomm?.participants
)

export const getCapacityConf: GetCapacityConf = createSelector(
  getParticipantsSettings,
  participantsSettings => participantsSettings?.conf
)

export const getMinPax: GetMinPax = createSelector(
  getParticipantsSettings,
  participantsSettings => participantsSettings?.minPax
)

export const getMaxPax: GetMaxPax = createSelector(
  getParticipantsSettings,
  participantsSettings => participantsSettings?.maxPax
)

export const getMinEqualsMaxPax: GetMinEqualsMaxPax = createSelector(
  getMinPax,
  getMaxPax,
  (min, max) => Boolean(min && max && min === max)
)
